import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Qc8110GetResultModel, Qc8110GetResultSchema } from './get.schema'

export async function fetchQc8110(id: string): Promise<Qc8110GetResultModel> {
  const response = await axios.get<Qc8110GetResultModel>(`/api/qc/qc8110/${id}`)
  return Qc8110GetResultSchema.parse(response.data)
}

export const getQc8110ByIdOptions = (id: string) =>
  queryOptions({
    queryKey: ['qc8110', id],
    queryFn: () => fetchQc8110(id),
  })
